module.exports = __webpack_public_path__ + "img/defaultImage-74799744dd7ba0b8d65e62b1bd9a56b7.svg";